/**
 * Team Configuration
 * 
 * This file contains the configuration for team groupings used in the
 * Employee Monitor dashboard. Modify these lists to change team assignments.
 */

// Administrators - these users are managers/admins, not part of dev teams
// Include both full names and intranet usernames (first initial + last name)
export const ADMIN_NAMES = [
  'mauro garcia',
  'mgarcia',
  'josh reid',
  'jreid',
  'andrew chiles',
  'achiles',
  'chase gullett',
  'cgullett',
  'jason bratcher',
  'jbratcher'
];

// Note: eLink Design employees are loaded from the database (/api/employees)
// PhishingBox employees are anyone not in Admin or eLink Design

// You can add additional team configurations here as needed
// For example:
// export const QA_TEAM = ['name1', 'name2'];
// export const DESIGN_TEAM = ['name1', 'name2'];

